var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.paymentUrl,"title":"Payment"}})
}
var staticRenderFns = []

export { render, staticRenderFns }